export default "__VITE_ASSET__DflbjobC__"